import { type FC, type ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import { useIsMobile } from "~/hooks/useIsMobile";
import { fontSizes } from "~/utils/theme";

interface Props {
  isActive?: boolean;
  children: ReactNode;
  onClick?: () => void;
}

export const NavItemWrapper: FC<Props> = ({ isActive, children, onClick }) => {
  const isMobile = useIsMobile();

  const color = isMobile ? "th.black" : "fg-accent";

  return (
    <Flex
      align="center"
      bg="transparent"
      color={color}
      cursor="pointer"
      fontSize={fontSizes.md}
      fontWeight="normal"
      justify="flex-start"
      letterSpacing="0.5px"
      lineHeight="150%"
      h="fit-content"
      onClick={onClick}
      px={0}
      textAlign="left"
      w="full"
      _active={{ bg: "transparent" }}
      _hover={{ bg: "transparent" }}
    >
      <Flex
        borderBottom="2px solid"
        borderColor={isActive ? color : "transparent"}
        px={0}
      >
        {children}
      </Flex>
    </Flex>
  );
};
